import { render, staticRenderFns } from "./MyBidsList.vue?vue&type=template&id=0925ef81&"
import script from "./MyBidsList.vue?vue&type=script&lang=js&"
export * from "./MyBidsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports